export default from './post-comment-list';



// WEBPACK FOOTER //
// ./app/containers/post-comment-list/index.js